import { useEffect, useState } from 'react'
import { animate } from 'framer-motion'

// Counts up from 0 to `value` on mount, with an ease-out feel.
export default function AnimatedNumber({ value, decimals = 0, prefix = '', delay = 0 }) {
  const [display, setDisplay] = useState(0)

  useEffect(() => {
    const controls = animate(0, value, {
      duration: 1.4,
      delay,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(v),
    })
    return () => controls.stop()
  }, [value, delay])

  const formatted = display.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })

  return (
    <span>
      {prefix}
      {formatted}
    </span>
  )
}
